import pluralize from 'pluralize';
import { Download } from 'lucide-react';
import { useSelector } from 'react-redux';
import { activeNetworkSelector } from 'redux/selectors';
import { useLazyExportOrganizationsQuery } from 'services/organizations';
import { toast } from 'react-hot-toast';

export const useSecondaryActions = ({ isLoading, meta, filters }) => {
  const { isManager } = useSelector(activeNetworkSelector);
  const [exportOrganizations, { isLoading: isExportingOrganizations }] = useLazyExportOrganizationsQuery();

  let secondaryActions = [
    {
      text: isLoading ? 'Loading...' : `Showing ${meta.total.toLocaleString()} ${pluralize('company', meta.total)}`,
    },
  ];

  if (isManager) {
    const action = () =>
      exportOrganizations({ filters }).then((res) => {
        const isError = res.error;
        toast(
          isError
            ? 'There was an unexpected error, try again or send us a chat.'
            : 'Export in progress — we’ll email it to you in a few minutes.',
          { icon: isError ? 'error' : 'success', id: 'export-csv-success' },
        );
      });

    secondaryActions = [
      ...secondaryActions,
      {
        action,
        icon: Download,
        text: 'Export',
        popoverContent: 'Export a CSV of these filtered results to your inbox',
        sx: { minWidth: '100px', justifyContent: 'flex-end', '&:hover': { backgroundColor: 'transparent' } },
        popoverContentSx: { '.tooltip-arrow': { left: '35px !important' } },
        loading: isExportingOrganizations,
      },
    ];
  }

  return secondaryActions;
};
